import { login } from 'public-layout/log-in/reducer';
import { signUp } from 'public-layout/sign-up/reducer';
import { changePassword } from 'public-layout/change-password/reducer';

export default { login, signUp, changePassword };
